import styled from "@emotion/styled";
const PROCESS_INDICATOR_DIAMETER = "5px";
const PROCESS_MARGIN = "8px";
export const StyledProcessTabsMobile = styled.div`
  .mobile-wrapper {
    .use-cases-tabs-mobile-component {
      .mobile-tabs-component {
        .asset-title {
          font-size: 1rem;
        }

        .mobile-tabs-navigation {
          padding-left: 0;

          .tab-nav-button-wrapper {
            padding-bottom: 20px;

            .tab-nav-button {
              min-width: 64px;
              position: relative;
              background-color: transparent;
              color: inherit;
              border-radius: none;
              padding-left: 0;
              padding-bottom: 0;

              &::before {
                position: absolute;
                content: "";
                display: flex;
                width: ${PROCESS_INDICATOR_DIAMETER};
                height: ${PROCESS_INDICATOR_DIAMETER};
                border-radius: 50%;
                background-color: transparent;
                border: 1px solid var(--tab-color);
                position: relative;
                top: 100%;
                top: ${`calc(100% + ${PROCESS_MARGIN})`};
                left: 0;
              }

              &::after {
                content: "";
                position: absolute;
                display: flex;
                left: calc(${PROCESS_INDICATOR_DIAMETER} + ${PROCESS_INDICATOR_DIAMETER} / 2);
                top: calc(100% + ${PROCESS_INDICATOR_DIAMETER} / 2 + 1px + ${PROCESS_MARGIN});
                width: 100%;
                background-color: var(--tab-color);
                height: 1px;
              }

              &.selected {
                color: var(--tab-color);

                &::before {
                  background-color: var(--tab-color);
                }
              }
            }
          }
        }
      }
    }
  }
`;
